<template>
    <div>
        <CreateList
            :addFromEventAttendees="$route.params.eventid"
            v-model="showCreateListDialog"
            @createdList="goToList"
            @updatedList="goToList"
        />

        <v-row v-if="error" style="min-height: 50vh" align="center" justify="center">
            <div>
                <v-col class="text-center" cols="12" >
                    <v-icon color="error"
                            size="50">
                        mdi-alert
                    </v-icon>
                </v-col>

                <v-col cols="12" class="text-h6 text-center">
                    {{ $t('general.errorLoadingEvent') }}
                </v-col>

                <v-col class="text-center" cols="12" >
                    <v-btn color="primary" @click="$router.back()">
                        {{ $t('general.goBack') }}
                    </v-btn>
                </v-col>
            </div>
        </v-row>

        <v-row justify="center"
               style="min-height: 50vh"
               align="center"
               v-if="loadingEvent">
            <v-progress-circular color="kbGold"
                                 indeterminate
                                 size="50">
            </v-progress-circular>
        </v-row>

        <v-row v-if="event">
            <v-col cols="12" v-if="!event.publish">
                <v-alert style="border-radius: 3px; border: none;"
                         type="info"
                         :value="true">
                    {{ $t('general.eventNotPublishedAndOutOfLists') }}
                </v-alert>
            </v-col>

            <v-col cols="12">
                <v-card color="kbWhite">
                    <v-card-text>
                        <h5 class="hidden-sm-and-up kbDarkBlueText--text">{{event.title}}</h5>
                        <h2 class="hidden-xs-only kbDarkBlueText--text text-center">{{event.title}}</h2>
                    </v-card-text>

                    <v-divider/>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-list color="kbLight">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlueText">
                                                group
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title class="kbDarkBlueText--text">
                                                {{ $t('general.people') }}
                                            </v-list-item-title>

                                            <v-list-item-subtitle>
                                                {{event.totalTickets}}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-list color="kbLight">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlueText">
                                                event_available
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title class="kbDarkBlueText--text">
                                                {{ $t('general.creationDate') }}
                                            </v-list-item-title>

                                            <v-list-item-subtitle>
                                                {{ event.createdAt | moment('DD/MM/YYYY hh:mm a') }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-list color="kbLight">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlueText">
                                                event
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title class="kbDarkBlueText--text">
                                                {{ $t('general.eventDate') }}
                                            </v-list-item-title>

                                            <v-list-item-subtitle>
                                                {{ event.starts | moment('DD/MM/YYYY hh:mm a') }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-list color="kbLight">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlueText">
                                                mdi-ticket
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title class="kbDarkBlueText--text">
                                                {{ $t('general.availableTickets') }}
                                            </v-list-item-title>

                                            <v-list-item-subtitle>
                                                {{ event.totalAvailable }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-list color="kbLight">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlueText">
                                                mdi-ticket-account
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title class="kbDarkBlueText--text">
                                                {{ $t('general.soldTickets') }}
                                            </v-list-item-title>

                                            <v-list-item-subtitle>
                                                {{ event.totalSold }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-list color="kbLight">
                                    <v-list-item>
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlueText">
                                                mdi-currency-usd
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title class="kbDarkBlueText--text">
                                                {{ $t('general.currency') }}
                                            </v-list-item-title>

                                            <v-list-item-subtitle>
                                                {{ event.currency }}
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                            <v-col class="px-6" cols="12" md="6" >
                                <v-switch @change="togglePublish()"
                                          color="kbDarkBlueText"
                                          hide-details
                                          :label="$t('general.publishEvent')"
                                          v-model="event.publish">
                                </v-switch>
                            </v-col>

                            <v-col cols="12" md="6">
                                <v-list color="kbLight">
                                    <v-list-item link @click="createCampaign">
                                        <v-list-item-action>
                                            <v-icon color="kbDarkBlueText">
                                                mdi-email-send-outline
                                            </v-icon>
                                        </v-list-item-action>

                                        <v-list-item-content>
                                            <v-list-item-title class="kbDarkBlueText--text">
                                                {{ $t('general.createList') }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-col>

                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12">
              <v-row>
                  <v-col cols="12">
                      <TicketsStatistics/>
                  </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
                <ListAttendees/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import eventsService from '@/services/eventsService'
import notifications from '@/libs/notifications'
import CreateList from '@/pages/App/People/dialogs/CreateList'
import ListAttendees from '@/pages/App/Events/EventsDetails/ListAttendees'
import TicketsStatistics from '@/pages/App/Events/EventsDetails/TicketsStatistics'
export default {
  components: {
    CreateList,
    ListAttendees,
    TicketsStatistics
  },
  created () {
    this.getEvent()
    this.$store.dispatch('getListsPersons')
  },
  data: () => ({
    showCreateListDialog: false,
    event: null,
    error: false,
    loadingEvent: false
  }),
  methods: {
    async getEvent () {
      try {
        this.loadingEvent = true
        const response = await this.$store.dispatch('getEvent', { eventId: this.$route.params.eventid })
        this.loadingEvent = false
        this.event = response
      } catch (e) {
        this.loadingEvent = false
        this.error = true
      }
    },
    async togglePublish () {
      try {
        await eventsService.updateEventProperty(
          this.$store.getters.token,
          this.$store.getters.companyUuid,
          this.$store.getters.appUuid,
          this.event._id,
          { publish: this.event.publish }
        )
      } catch (error) {
        this.event.publish = !this.event.publish
        notifications.error(error.message)
      }
    },
    async createCampaign () {
      try {
        // show create list
        this.showCreateListDialog = true
      } catch (error) {
        console.error(error)
      }
    },
    goToList (list) {
      this.$router.push(
        {
          name: 'ListDetails',
          params: {
            listid: list._id
          }
        }
      )
    }
  }
}
</script>
